import React, { FunctionComponent, memo, ReactNode, useMemo } from 'react';

import { PaletteType } from '@gojob/ui-bits/styles/PaletteProvider';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import Flat from './Flat';
import Rounded from './Rounded';
import Wave from './Wave';

export type BackgroundProps = {
  variant?: 'rounded' | 'wave' | 'flat';
  color?: PaletteType;
  children: ReactNode;
};

const Background: FunctionComponent<BackgroundProps> = (props) => {
  const { variant, children } = props;
  const palette = usePalette();

  const Content = useMemo(() => {
    switch (variant) {
      case 'rounded':
        return <Rounded color={palette.background}>{children}</Rounded>;
      case 'wave':
        return <Wave waveColor={palette.background}>{children}</Wave>;
      default:
        return <Flat color={palette.background}>{children}</Flat>;
    }
  }, [variant, children, palette]);

  return <>{Content}</>;
};

export default memo(Background) as typeof Background;
